import { render, staticRenderFns } from "./AttractionEditing.vue?vue&type=template&id=19935b81&scoped=true"
import script from "./AttractionEditing.vue?vue&type=script&lang=js"
export * from "./AttractionEditing.vue?vue&type=script&lang=js"
import style0 from "./AttractionEditing.vue?vue&type=style&index=0&id=19935b81&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19935b81",
  null
  
)

export default component.exports